<ng-template #template>


  <aside class="sticky {{
      asideState.type === 'full' ? 'w-0 md:min-w-64 md:max-w-64 md:w-64' : 'w-0 md:max-w-24 md:min-w-24 md:w-24'
    }} transition-all duration-30 pt-2 pb-10 px-4 hidden md:inline bg-bg text-white bg-clip-padding shadow-sm h-full overflow-x-hidden">

    <div class="flex justify-start flex-col gap-2 mt-2">
      <img (click)="asideService.setFullMenu()" class="h-8 transition duration-300 mb-4 cursor-pointer {{asideState.type === 'icons' ? 'block' : 'hidden'}}" src="assets/img/logo-a-red.svg" alt="Logo alonso min">
      <img (click)="asideService.setIconsMenu()" class="h-10 transition duration-300 mb-4 cursor-pointer {{asideState.type== 'full' ? 'block' : 'hidden'}}"
        src="assets/img/logo.svg" alt="Logo alonso">

      <!-- Selector de sucursal (operadoras) -->
      <div *ngIf="isOperator && offices.length" class="office-switcher relative mb-3">
        <button type="button" (click)="toggleOfficeDropdown($event)" [disabled]="switchingOffice"
          class="w-full flex items-center gap-2 rounded-xl bg-border px-3 py-2.5 hover:opacity-90 transition disabled:opacity-60"
          [class.justify-center]="asideState.type !== 'full'"
          [attr.title]="activeOffice?.name">
          <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
          </svg>
          <span *ngIf="asideState.type === 'full'" class="flex-1 min-w-0 text-left">
            <span class="block text-[10px] uppercase tracking-wide opacity-60 leading-none mb-0.5">Sucursal</span>
            <span class="block text-sm font-semibold truncate leading-tight">{{ activeOffice?.name || 'Selecciona' }}</span>
          </span>
          <svg *ngIf="asideState.type === 'full'" class="w-4 h-4 shrink-0 transition-transform" [class.rotate-180]="officeDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </button>
        <div *ngIf="officeDropdownOpen"
          class="absolute z-50 mt-1 left-0 min-w-[12rem] rounded-xl bg-white text-dark shadow-lg overflow-hidden py-1 animate-fade-in">
          <button *ngFor="let office of offices" type="button" (click)="onSwitchOffice(office.id, $event)"
            class="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2"
            [class.font-semibold]="office.id === activeOffice?.id">
            <span class="w-1.5 h-1.5 rounded-full shrink-0" [ngClass]="office.id === activeOffice?.id ? 'bg-primary' : 'bg-transparent'"></span>
            <span class="truncate">{{ office.name }}</span>
          </button>
        </div>
      </div>

      <ng-container *ngFor="let menu of menuItems" >
        <app-aside-nav-item *ngIf="permissionCheck(menu)"  [asideState]="asideState" [menuItem]="menu"></app-aside-nav-item>
      </ng-container>
      <!--<div class="flex flex-col px-4 gap-y-2 {{asideState.type== 'full' ? 'block' : 'hidden'}}">
        <button class="flex rounded-2xl px-4 gap-x-2 py-3 justify-start flex-row items-center bg-border">
          <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
          <p class="text-sm font-semibold text-start">Producto</p>
        </button>
        <button class="flex rounded-2xl px-4 gap-x-2 py-3 justify-start flex-row items-center bg-border">
          <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
          <p class="text-sm font-semibold text-start">Curso</p>
        </button>
        <button class="flex rounded-2xl px-4 gap-x-2 py-3 justify-start flex-row items-center bg-border">
          <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
          <p class="text-sm font-semibold text-start">Examen</p>
        </button>
      </div>-->
    </div>

  </aside>


  <aside [ngClass]="{'hidden': !mobileMenuOpen}" class="absolute inset-0 z-40 hidden">
    <div id="menu-mask" class="absolute inset-0 mask" (click)="asideService.closeMobileMenu()"></div>
    <button class=" rounded-full bg-white text-white fixed right-2 top-2 z-20 p-2" (click)="asideService.closeMobileMenu()">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-8 stroke-black" viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    </button>

    <div [@slideInOut]="menuState" id="menu-sidebar" class="absolute inset-0 overflow-y-auto top-0 left-0 bottom-0 w-3/4 bg-white text-white z-50 pb-16 pt-8 flex gap-4 flex-col">


      <div class="flex justify-center flex-col gap-4 mt-2">
        <img (click)="asideService.setIconsMenu()" class="h-9 transition duration-300 mb-4 cursor-pointer"
        src="assets/img/logo.svg" alt="Logo alonso">

        <!-- Selector de sucursal (operadoras) -->
        <div *ngIf="isOperator && offices.length" class="office-switcher relative mb-3 px-4">
          <button type="button" (click)="toggleOfficeDropdown($event)" [disabled]="switchingOffice"
            class="w-full flex items-center gap-2 rounded-xl bg-gray-100 text-dark px-3 py-2.5">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
            </svg>
            <span class="flex-1 min-w-0 text-left">
              <span class="block text-[10px] uppercase tracking-wide opacity-60 leading-none mb-0.5">Sucursal</span>
              <span class="block text-sm font-semibold truncate leading-tight">{{ activeOffice?.name || 'Selecciona' }}</span>
            </span>
            <svg class="w-4 h-4 shrink-0 transition-transform" [class.rotate-180]="officeDropdownOpen"
              fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
          <div *ngIf="officeDropdownOpen"
            class="absolute z-50 mt-1 left-4 right-4 rounded-xl bg-white text-dark shadow-lg overflow-hidden py-1">
            <button *ngFor="let office of offices" type="button" (click)="onSwitchOffice(office.id, $event)"
              class="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2"
              [class.font-semibold]="office.id === activeOffice?.id">
              <span class="w-1.5 h-1.5 rounded-full shrink-0" [ngClass]="office.id === activeOffice?.id ? 'bg-primary' : 'bg-transparent'"></span>
              <span class="truncate">{{ office.name }}</span>
            </button>
          </div>
        </div>

        <ng-container *ngFor="let menu of menuItems" >
          <app-aside-nav-item *ngIf="permissionCheck(menu)" [menuItem]="menu" [asideState]="asideState"></app-aside-nav-item>
        </ng-container>
        <div class="flex flex-col px-4 gap-y-2 justify-start">
          <button class="flex rounded-xl px-4 gap-x-2 py-2 justify-start flex-row items-center bg-border">
            <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
            <p class="text-sm font-semibold text-start">Producto</p>
          </button>
          <button class="flex rounded-xl px-4 gap-x-2 py-2 justify-start flex-row items-center bg-border">
            <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
            <p class="text-sm font-semibold text-start">Curso</p>
          </button>
          <button class="flex rounded-xl px-4 gap-x-2 py-2 justify-start flex-row items-center bg-border">
            <svg  xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
            <p class="text-sm font-semibold text-start">Convocatoria de Examen</p>
          </button>
        </div>
      </div>
    </div>
  </aside>

</ng-template>
